import '../../../frontend/images/new_register_page/black-friday-md.png';
import '../../../frontend/images/new_register_page/black-friday-sm.png';
import '../registration/components/form';
import './components/login_form';
import './components/registration_form';
import './components/side_hero';
import './index.scss';
import 'components/alert';
import 'components/campaigns/interventions/sessions_side_hero';
import 'components/social_login';
import LoginRegister from 'utils/login_register';
import zaraz from 'utils/trackers/zaraz';

(() => {
  'use strict';

  // login
  const $formLogin = $('#login_form');

  $formLogin.on('submit', e => {
    e.stopPropagation();

    window['dataLayer'].push({
      event: 'login',
      method: 'Formulário'
    });
  });

  // register
  const $formRegister = $('#registration_form');
  let registered = false;

  if (!registered) {
    $formRegister.on('submit', e => {
      e.stopPropagation();

      registered = true; // avoid triggering multiple events

      zaraz.track('User Registered', {
        method: 'Email',
        location_id: 'conta cadastrar'
      });

      window['dataLayer'].push({
        event: 'sign_up',
        method: 'Formulário',
        is_checkout: false
      });
    });
  }

  // social
  const $btnSocial = $('[data-btn-social]');

  $btnSocial.on('click', () => {
    window['dataLayer'].push({
      event: $btnSocial.data().btnSocial,
      method: 'Social'
    });
  });

  // recovery password
  const $buttonRecovery = $('#buttonRecoveryPassword');

  $buttonRecovery.on('click', () => {
    LoginRegister.newLoginModal(window.location.pathname, {
      initial_screen: 'recovery'
    });
  });
})();
